import { authApi } from './index';

export const getStartListsSummary = async (meetId) => {
  try {
    const response = await authApi.get(`/meets/${meetId}/start-lists/summary`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getStartListDetails = async (
  meetId,
  eventTypeCode,
  ageGroup,
  gender
) => {
  try {
    const response = await authApi.get(`/meets/${meetId}/start-lists/details`, {
      params: {
        eventTypeCode: eventTypeCode || '',
        ageGroup: ageGroup || '',
        gender: gender || '',
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const getEligibleAthletes = async (meetId, eventTypeCode, ageGroup, gender) => {
  try {
    const response = await authApi.get(`/meets/${meetId}/start-lists/eligible-athletes`, {
      params: {
        eventTypeCode: eventTypeCode || '',
        ageGroup: ageGroup || '',
        gender: gender || '',
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
}

export const getStartListGenerationSettings = async (meetId, startListId, roundType) => {
  try {
    const response = await authApi.get(
      `/meets/${meetId}/start-lists/${startListId}/generation-settings/${roundType}`
    );
    return response;
  } catch (error) {
    throw error;
  }
};

// NEW: Save heats for an event
export const saveHeats = async (meetId, data) => {
  try {
    const response = await authApi.put(
      `/meets/${meetId}/start-lists/heats`,
      data
    );
    return response;
  } catch (error) {
    throw error;
  }
};

// NEW: Save semis for an event (you'll need to create similar endpoints)
export const saveSemis = async (meetId, data) => {
  try {
    const response = await authApi.put(
      `/meets/${meetId}/start-lists/semis`,
      data
    );
    return response;
  } catch (error) {
    throw error;
  }
};

// NEW: Save finals for an event
export const saveFinals = async (meetId, data) => {
  try {
    const response = await authApi.put(
      `/meets/${meetId}/start-lists/finals`,
      data
    );
    return response;
  } catch (error) {
    throw error;
  }
};


// The PDF and the CSV hold the start lists whose ids are given: the Start Lists
// page sends the ones in the rows its filters leave showing.
export const getDownloadStartListPdf = async (meetId, startListIds) => {
  try {
    const response = await authApi.post(
      `/meets/${meetId}/start-lists/export-all-pdf`,
      { startListIds },
      { responseType: 'blob' }
    );
    return response;
  } catch (err) {
    throw err;
  }
}

export const getDownloadStartListCsv = async (meetId, startListIds) => {
  try {
    const response = await authApi.post(
      `/meets/${meetId}/start-lists/export-all-csv`,
      { startListIds },
      { responseType: 'blob' }
    );
    return response;
  } catch (err) {
    throw err;
  }
}
